import { createContext } from 'react';

import { Store, createStore } from '../../../core/store/store.js';
import { CategoricalBarChartState, initialState } from '../types/state.js';

export const CategoricalBarChartStateContext = createContext<
  Store<CategoricalBarChartState>
>(createStore<CategoricalBarChartState>(initialState));

CategoricalBarChartStateContext['displayName'] =
  'CategoricalBarChartStateContext';
